import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { useState } from 'react';
/**
 * Internal dependencies
 */
import Button from './Button';
import DateDropdown from './DateDropdown';
import Dropdown from './Dropdown';
const SearchUpcomingEvents = ({ region, categories }) => {
    const [formData, updateFormData] = useState({
        category: '',
        eventDate: ''
    });
    const handleChange = (e, actionMeta) => {
        updateFormData({
            ...formData,
            [actionMeta.name]: e.value
        });
    };
    const handleSubmit = () => {
        window.location.href = `${window.location.href}/events?region=${region}&category=${formData.category}&eventDate=${formData.eventDate}`;
    };
    return (_jsxs("form", { className: "base-grid", children: [_jsx("div", { className: "col-span-full desktop:col-span-4 desktop:flex desktop:flex-col desktop:justify-center", children: _jsx("h4", { className: "text-black", children: __('Search upcoming events', 'scenic-rim') }) }), _jsx("div", { className: "col-span-full tablet-portrait:col-span-4 tablet-landscape:col-span-5 desktop:col-span-3", children: _jsx(DateDropdown, { onChange: handleChange, name: "eventDate" }) }), categories && _jsx("div", { className: "col-span-full tablet-portrait:col-span-4 tablet-landscape:col-span-5 desktop:col-span-3", children: _jsx(Dropdown, { options: JSON.parse(categories), placeholder: "Type", onChange: handleChange, name: "category" }) }), _jsx("div", { className: "col-span-full flex justify-end tablet-landscape:col-span-2 tablet-landscape:flex-col tablet-landscape:items-end desktop:col-span-2 ", children: _jsx(Button, { onClick: handleSubmit, children: __('Search Events', 'scenic-rim') }) })] }));
};
export default SearchUpcomingEvents;
